import { app } from '../../../../../app';
import { Controller } from './sms-reset-pin.controller';

app.component('companyUserDirectoriesManageUserSmsResetPin', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./sms-reset-pin.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/sms-reset-pin/sms-reset-pin.component.js